import checkmark from 'Assets/Icons/gray-checkmark.png'
import { Button, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material'

interface ServiceCardDisplayProps {
  header: string
  description?: string | null
  selected: boolean
  imageElement: JSX.Element | null
  onClick: () => void
}

export function SimpleSelectableCard (props: ServiceCardDisplayProps): JSX.Element {
  return <Card sx={{ borderRadius: '15px' }}>
    <CardActionArea
      onClick={props.onClick}
      data-active={props.selected ? '' : undefined}
      sx={{
        height: '100%',
        '&[data-active]': {
          backgroundColor: 'action.selected',
          '&:hover': {
            backgroundColor: 'action.selectedHover'
          }
        }
      }}
    >
      <CardContent sx={{ height: '100%' }}>
        <Grid container xs={12}>
          <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
            {props.imageElement ?? <></>}
          </Grid>
          <Grid item xs={8}>
            <Typography variant="h6" component="div">
              {props.header}
            </Typography>
            <Typography variant="body2">
              {props.description}
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {props.selected && <Button
              variant='outlined'
              className='select-button selected'
            >
              <img src={checkmark} alt={'checkmark'}/>
            </Button>}
          </Grid>
        </Grid>
      </CardContent>
    </CardActionArea>
  </Card>
}
